import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface BaoCaoSLTKs {
  name: string;
  api_token: string;
}

export interface BaoCaoSLTKsListInfor {
  errors: unknown;
  baoCaoSLTKs: BaoCaoSLTKs;
  isAuthenticated: boolean;
}

@Module
export default class BaoCaoSLTKsModule
  extends VuexModule
  implements BaoCaoSLTKsListInfor
{
  errors = {};
  baoCaoSLTKs = {} as BaoCaoSLTKs;
  isAuthenticated = !!JwtService.getToken();

  get BaoCaoSLTKs() {
    return this.baoCaoSLTKsListData;
  }

  @Mutation
  [Mutations.BAO_CAO_SLTKS_LIST_DATA](BaoCaoSLTKs) {
    this.baoCaoSLTKsListData = BaoCaoSLTKs;
  }

  @Action
  [Actions.BAO_CAO_SLTKS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/baocao_sltk", payload)
        .then((data) => {
          this.context.commit(Mutations.BAO_CAO_SLTKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.BAO_CAO_SLTK_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("baocao_sltk/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.BAO_CAO_SLTKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.BAO_CAO_SLTK_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/baocao_sltk", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.BAO_CAO_SLTKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.BAO_CAO_SLTK_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/baocao_sltk",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.BAO_CAO_SLTKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.BAO_CAO_SLTK_UPDATE_STATUS](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/baocao_sltk/${payload.id}/update-status`,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.BAO_CAO_SLTKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
